import React from "react";
import PropTypes from "prop-types";
import STRINGS from "Constants/Strings";
import AppConstants from "Constants/AppConstants";
import SignaturePad from "react-signature-canvas";
import { HTTP_STATUS } from "Communication/Constants";
import PopupModal from "Components/Common/PopupModal/PopupModal";
import AuthBody from "../Common/AuthBody/AuthBody";
import Stepper from "../Common/Stepper/Stepper";
import { isScanningAllowed } from "Utils/CommonUtilities";
import "../Documents/Documents.scss";
import { isInBranchFlow } from "../../Utils/LogicUtilities";

class Signature extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      choice: "",
      showInstructions: false,
      documentList: [],
    };
  }

  componentDidMount() {
    const { getDataFromServer, activeProduct } = this.props;
    console.log("componentDidMount", activeProduct);
    getDataFromServer(AppConstants.APPLICATIONSTEP.SIGNATURE, (response) => {
      this.setFormData(response);
    });
    if (
      activeProduct.esign &&
      Array.isArray(activeProduct.esign) &&
      activeProduct.esign.length > 0
    ) {
      this.setState({ documentList: activeProduct.esign });
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { activeProduct } = this.props;
    if (activeProduct && prevProps.activeProduct !== activeProduct) {
      if (
        activeProduct.esign &&
        Array.isArray(activeProduct.esign) &&
        activeProduct.esign.length > 0
      ) {
        this.setState({ documentList: activeProduct.esign });
      }
    }
  }

  setFormData = () => {};

  handleBack = () => {
    const { handleBack, goToPage2, showPage3 } = this.props;
    console.log("handleBack", showPage3);
    if (isInBranchFlow() && showPage3) {
      goToPage2();
    } else {
      handleBack(AppConstants.APPLICATIONSTEP.SIGNATURE);
    }
  };

  handleChange = (choice) => {
    this.setState({ choice });
  };

  handleContinue = (currentPage) => {
    console.log("handleContinue");
    const { handleContinue, showPage1 } = this.props;
    const { choice, showInstructions, documentList } = this.state;

    if (isInBranchFlow()) {
      this.clearChoice();
      handleContinue(choice, { currentPage }, documentList);
    } else {
      if (showPage1 && !showInstructions) {
        this.setState({ showInstructions: true });
      } else {
        this.clearChoice();
        handleContinue(choice, { currentPage });
      }
    }
  };

  clearChoice = () => {
    this.setState({ choice: "", showInstructions: false });
  };

  fileDrop = (e) => {
    e.preventDefault();
    const { addDocumentData } = this.props;
    const { documentList } = this.state;
    const uploadFiles = e.dataTransfer.files;
    const currFile = uploadFiles[0];
    const reader = new FileReader();

    reader.readAsBinaryString(currFile);

    reader.onload = () => {
      const document = {
        documentName: uploadFiles[0].name,
        documentSource: uploadFiles[0],
        documentId: documentList.length,
        onError: this.handleUploadError,
      };
      this.setState({
        documentList: [...documentList, document],
      });
      addDocumentData(document);
    };
  };

  handleFileChange = (e) => {
    const { documentList } = this.state;
    const { addDocumentData } = this.props;
    const uploadFiles = e.target.files;
    const currFile = uploadFiles[0];
    const reader = new FileReader();
    reader.readAsBinaryString(currFile);

    reader.onload = () => {
      const document = {
        documentName: uploadFiles[0].name,
        documentSource: uploadFiles[0],
        documentId: documentList.length,
        onError: this.handleUploadError,
      };
      this.setState({
        documentList: [...documentList, document],
      });
      // Clear the input value
      if (this.upload) {
        this.upload.value = null;
      }
      addDocumentData(document);
    };
  };

  handleUploadError = (documentId) => {
    const { documentList } = this.state;
    // Remove the failed document from the list
    const updatedList = documentList.filter(
      (doc) => doc.documentId !== documentId
    );
    this.setState({ documentList: updatedList });
  };

  handleDeleteFile = (idx) => {
    const { documentList } = this.state;
    const updatedList = documentList.filter((_, index) => index !== idx);
    this.setState({ documentList: updatedList });
    const { deleteDocument } = this.props;
    deleteDocument(idx);
  };

  render() {
    const {
      steps,
      activeStepID,
      showPage1,
      showPage2,
      showPage3,
      showModal,
      type,
      modal,
      toggleModal,
      handlePopupModalBtnClick,
      activeProduct,
    } = this.props;
    const { showInstructions, documentList } = this.state;
    const actionComponent = (
      <div className="[ signature-container ]">
        <Stepper
          steps={AppConstants.SIGNATURE.STEPS}
          active={showPage2 ? 2 : 1}
        />
        <div className="[ form-title ]">{STRINGS.SIGNATURE.TITLE}</div>

        <div className="[ form-container ]">
          {showPage1 && !isInBranchFlow() && (
            <div>
              <div className="[ mb-3 ] [ alert alert-secondary ]" role="alert">
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <h3 className="[ alert-heading ]">
                      {STRINGS.BRANCH.SIGNATURE.INSTRUCTION_PAGE1_TITLE_ALT}
                    </h3>
                  </div>
                </div>
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <p>
                      <strong>
                        {STRINGS.SIGNATURE.INSTRUCTION_PAGE1_SUBTITLE}
                      </strong>
                    </p>
                    <p>
                      {STRINGS.SIGNATURE.INSTRUCTION_PAGE1_DESCRIPTION.split(
                        AppConstants.TEMPLATE.PRODUCT
                      ).join(activeProduct.productName)}
                    </p>
                    <p>{STRINGS.SIGNATURE.INSTRUCTION_PAGE1_DESCRIPTION1}</p>
                    <p>{STRINGS.SIGNATURE.INSTRUCTION_PAGE1_DESCRIPTION2}</p>
                    <p>{STRINGS.SIGNATURE.INSTRUCTION_PAGE1_DESCRIPTION3}</p>
                  </div>
                </div>
              </div>

              <div className="[ mb-3 ]">
                <div className="[ row ]">
                  <div className="[ col-lg-6 ] [ offset-lg-3 ]">
                    <div
                      className=" [ e-sig ] "
                      onClick={this.handleContinue}
                      onKeyDown={this.handleKeyDown}
                      role="button"
                      tabIndex="0"
                    >
                      <div className="[ flex-row justify-content-center text-center ]">
                        <i className="[ fas fa-file-signature ]" />
                      </div>
                      <div className="[ e-sig__text ] ">
                        {STRINGS.SIGNATURE.CLICKTOBEGIN}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* BRANCH FLOW - PAGE 1 */}
          {showPage1 && isInBranchFlow() && (
            <div>
              <div className="[ mb-3 ] [ alert alert-secondary ]" role="alert">
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <h3 className="[ alert-heading ]">
                      {STRINGS.BRANCH.SIGNATURE.INSTRUCTION_PAGE1_TITLE_ALT}
                    </h3>
                  </div>
                </div>
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <p>
                      <strong>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE1_SUBTITLE_ALT
                        }
                      </strong>
                    </p>
                    <p>
                      {STRINGS.BRANCH.SIGNATURE.INSTRUCTION_PAGE1_DESCRIPTION_ALT.split(
                        AppConstants.TEMPLATE.PRODUCT
                      ).join(activeProduct.productName)}
                    </p>
                    <p>
                      {
                        STRINGS.BRANCH.SIGNATURE
                          .INSTRUCTION_PAGE1_DESCRIPTION1_ALT
                      }
                    </p>
                    <p>
                      <strong>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE1_DESCRIPTION2_ALT
                        }
                      </strong>
                    </p>
                    <p>
                      {
                        STRINGS.BRANCH.SIGNATURE
                          .INSTRUCTION_PAGE1_DESCRIPTION3_ALT
                      }
                    </p>
                  </div>
                </div>
              </div>

              <div className="[ mb-3 ]">
                <div className="[ row ]">
                  <div className="[ col-lg-6 ] [ offset-lg-3 ]">
                    <button
                      type="button"
                      className="[ submit-btn btn ] [ w-100 ]"
                      style={{
                        borderRadius: ".5em",
                        backgroundColor: "#01aeef",
                        color: "#fff",
                      }}
                      onClick={this.handleContinue}
                    >
                      <i
                        className="[ fas fa-file-signature mr-2 ]"
                        aria-hidden="true"
                      />
                      {STRINGS.BRANCH.SIGNATURE.CLICKTOBEGIN_ALT}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* REGULAR FLOW - PAGE 2 */}
          {showPage2 && !isInBranchFlow() && (
            <div>
              <div className="[ mb-3 ] [ alert alert-info ]" role="alert">
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <h3 className="[ alert-heading ]">
                      {STRINGS.SIGNATURE.INSTRUCTION_PAGE2_TITLE}
                    </h3>
                  </div>
                </div>
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <p>
                      <strong>
                        {STRINGS.SIGNATURE.INSTRUCTION_PAGE2_SUBTITLE}
                      </strong>
                    </p>
                    <p>{STRINGS.SIGNATURE.INSTRUCTION_PAGE2_DESCRIPTION}</p>
                    <p>{STRINGS.SIGNATURE.INSTRUCTION_PAGE2_DESCRIPTION1}</p>
                    <p>{STRINGS.SIGNATURE.INSTRUCTION_PAGE2_DESCRIPTION2}</p>
                    <p>{STRINGS.SIGNATURE.INSTRUCTION_PAGE2_DESCRIPTION3}</p>
                  </div>
                </div>
              </div>
              <div className="[ mb-3 ]">
                <div className="[ row ]">
                  <div className="[ col-lg-6 ] [ offset-lg-3 ]">
                    <button
                      className="[ btn submit-btn ] [ w-100 ]"
                      onClick={() => this.handleContinue(2)}
                    >
                      {STRINGS.COMMON.CONTINUEBTN}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* BRANCH FLOW - PAGE 2 */}
          {showPage2 && isInBranchFlow() && (
            <div>
              <div className="[ mb-3 ] [ alert alert-info ]" role="alert">
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <h3 className="[ alert-heading ]">
                      {STRINGS.BRANCH.SIGNATURE.INSTRUCTION_PAGE2_TITLE_ALT}
                    </h3>
                  </div>
                </div>
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <div className="[ mb-3 ]">
                      <p>
                        <strong>
                          {
                            STRINGS.BRANCH.SIGNATURE
                              .INSTRUCTION_PAGE2_SUBTITLE_ALT
                          }
                        </strong>
                      </p>
                      <p>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE2_DESCRIPTION_ALT
                        }
                      </p>
                      <p>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE2_DESCRIPTION_1_ALT
                        }
                      </p>
                      <p>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE2_DESCRIPTION_2_ALT
                        }
                      </p>
                    </div>
                    <div className="[ mb-3 ]">
                      <p>
                        <strong>
                          {
                            STRINGS.BRANCH.SIGNATURE
                              .INSTRUCTION_PAGE2_SUBTITLE_1_ALT
                          }
                        </strong>
                      </p>
                      <p>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE2_DESCRIPTION_3_ALT
                        }
                      </p>
                      <p>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE2_DESCRIPTION_4_ALT
                        }
                      </p>
                      <p>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE2_DESCRIPTION_5_ALT
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* FILE UPLOADER */}
              <div className="[ mb-3 ]">
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <div className="[ upload-area-container ]">
                      <div
                        className="[ upload-area ]"
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={this.fileDrop}
                      >
                        <input
                          className="[ click-upload ]"
                          type="file"
                          ref={(ref) => {
                            this.upload = ref;
                          }}
                          onChange={(e) => this.handleFileChange(e)}
                          accept="image/*,.pdf"
                          multiple
                        />

                        <span
                          className="[ fas fa-folder-open ]"
                          aria-hidden="true"
                        />

                        <span className="[ browse-files-text ]">
                          {STRINGS.DOCUMENT_UPLOAD.CLICK_TO_BROWSE}
                        </span>

                        <span
                          className="[ click-link ]"
                          onClick={() => this.upload.click()}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              this.upload.click();
                            }
                          }}
                          role="button"
                          tabIndex="0"
                        >
                          {STRINGS.DOCUMENT_UPLOAD.CLICK_TO_BROWSE_LINK}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* ATTACHED DOCUMENTS */}
              <div className="[ mb-3 ]">
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <div className="[ details-section ]">
                      <div className="[ row ] [ details-section__header ]">
                        <div className="[ col-12 ]">
                          <h3
                            className="[ d-flex justify-content-between align-items-center ]"
                            style={{ color: "#2196F3", fontSize: 13 }}
                          >
                            ATTACHED DOCUMENTS
                          </h3>
                        </div>
                      </div>

                      <div className="[ row ] [ list-area-container ]">
                        <div className="[ col-12 ]">
                          {documentList.length > 0 ? (
                            <div className="[ details-section ]">
                              <div
                                className="[ row ] [ details-section__item ]"
                                style={{
                                  padding: "3px",
                                  fontSize: 15,
                                  fontWeight: "bold",
                                }}
                              >
                                <div className="[ col-8 ]">File</div>
                                <div className="[ col-3 ]">File Type</div>
                                <div className="[ col-1 ]">Delete</div>
                              </div>

                              {documentList.map((file, index) => (
                                <div
                                  key={`file-${file.documentId}-${file.documentName}`}
                                  className="[ row ] [ details-section__item ]"
                                  style={{ padding: "3px" }}
                                >
                                  <div className="[ col-8 ]">
                                    {file.documentName}
                                  </div>

                                  <div className="[ col-3 ]">
                                    {file.documentName.split(".").pop()}
                                  </div>

                                  <div className="[ col-1 ]">
                                    <span
                                      role="button"
                                      className="[ fas fa-trash ]"
                                      onClick={() =>
                                        this.handleDeleteFile(index)
                                      }
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "Enter" ||
                                          e.key === " "
                                        ) {
                                          this.handleDeleteFile(index);
                                        }
                                      }}
                                      tabIndex="0"
                                    >
                                      <span className="sr-only">
                                        delete file
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="[ row ] [ details-section__item ]">
                              <div className="[ col-12 ]">
                                <div
                                  className="[ text-muted ]"
                                  style={{ padding: "1.25rem" }}
                                >
                                  No attached files.
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="[ mb-3 ]">
                <div className="[ row ]">
                  <div className="[ col-lg-6 ] [ offset-lg-3 ]">
                    <button
                      type="button"
                      className="[ btn submit-btn ] [ w-100 ]"
                      onClick={() => this.handleContinue(2)}
                    >
                      {STRINGS.COMMON.CONTINUEBTN}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* REGULAR FLOW - PAGE 3 */}
          {showPage3 && !isInBranchFlow() && (
            <div>
              <div className="[ alert alert-warning ]">
                <h3 className="[ alert-heading ]">
                  {STRINGS.SIGNATURE.INSTRUCTION_PAGE3_TITLE}
                </h3>
                <p>{STRINGS.SIGNATURE.INSTRUCTION_PAGE3_DESCRIPTION}</p>
              </div>
              <div className="[ mb-3 ]">
                <div className="[ row ]">
                  <div className="[ col-lg-6 ] [ offset-lg-3 ]">
                    <button
                      className="[ btn submit-btn w-100 ]"
                      onClick={() => this.handleContinue(3)}
                    >
                      {STRINGS.COMMON.CONTINUEBTN}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* BRANCH FLOW - PAGE 3 */}
          {showPage3 && isInBranchFlow() && (
            <div>
              <div className="[ mb-3 ][ alert alert-warning ]">
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <h3 className="[ alert-heading ]">
                      {STRINGS.BRANCH.SIGNATURE.INSTRUCTION_PAGE3_TITLE_ALT}
                    </h3>
                    <p>
                      {
                        STRINGS.BRANCH.SIGNATURE
                          .INSTRUCTION_PAGE3_DESCRIPTION_ALT
                      }
                    </p>
                  </div>
                </div>
                <div className="[ row ]">
                  <div className="[ col-12 ]">
                    <div className="[ mb-3 ]">
                      <p>
                        <strong>
                          {
                            STRINGS.BRANCH.SIGNATURE
                              .INSTRUCTION_PAGE3_SUBTITLE_ALT
                          }
                        </strong>
                      </p>
                      <p>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE3_DESCRIPTION_1_ALT
                        }
                      </p>
                      <p>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE3_DESCRIPTION_2_ALT
                        }
                      </p>
                      <p>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE3_DESCRIPTION_3_ALT
                        }
                      </p>
                    </div>
                    <div className="[ mb-3 ]">
                      <p>
                        <strong>
                          {
                            STRINGS.BRANCH.SIGNATURE
                              .INSTRUCTION_PAGE3_SUBTITLE_1_ALT
                          }
                        </strong>
                      </p>
                      <p>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE3_DESCRIPTION_4_ALT
                        }
                      </p>
                      <p>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE3_DESCRIPTION_5_ALT
                        }
                      </p>
                      <p>
                        {
                          STRINGS.BRANCH.SIGNATURE
                            .INSTRUCTION_PAGE3_DESCRIPTION_6_ALT
                        }
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="[ mb-3 ]">
                <div className="[ row ]">
                  <div className="[ col-lg-6 ] [ offset-lg-3 ]">
                    <button
                      type="button"
                      className="[ submit-btn btn ] [ w-100 ]"
                      style={{
                        borderRadius: ".5em",
                        backgroundColor: "#01aeef",
                        color: "#fff",
                      }}
                      onClick={() => this.handleContinue(3)}
                    >
                      {STRINGS.COMMON.CONTINUEBTN}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );

    return (
      <>
        {showInstructions && (
          <PopupModal
            type={AppConstants.MODALTYPE.INFORMATION}
            description={STRINGS.SIGNATURE.ESIGN_END_MESSAGE}
            toggleModal={this.handleContinue}
            popupBtnClick={this.handleContinue}
            showModal={showInstructions}
            btnText={STRINGS.POPUPMODAL.OKBUTTON}
          />
        )}

        {showModal && (
          <PopupModal
            type={type}
            title={modal.title}
            description={modal.description}
            description2={modal.description2}
            toggleModal={toggleModal}
            showModal={showModal}
            popupBtnClick={
              type === AppConstants.MODALTYPE.SUCCESS
                ? () => handlePopupModalBtnClick()
                : () => {}
            }
            closeBtnClick={
              type === AppConstants.MODALTYPE.SUCCESS
                ? () => handlePopupModalBtnClick()
                : () => {}
            }
            btnText={STRINGS.POPUPMODAL.OKBUTTON}
          />
        )}

        <AuthBody
          actionComponent={actionComponent}
          memberCreation
          handleBack={this.handleBack}
        />
      </>
    );
  }
}

Signature.propTypes = {
  showModal: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  modal: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    description2: PropTypes.string,
  }).isRequired,
  toggleModal: PropTypes.func.isRequired,
  getDataFromServer: PropTypes.func,
  handleContinue: PropTypes.func,
  handleBack: PropTypes.func.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      title: PropTypes.string,
    })
  ),
  activeStepID: PropTypes.number,
  showPage1: PropTypes.bool.isRequired,
  showPage2: PropTypes.bool.isRequired,
  showPage3: PropTypes.bool.isRequired,
  handlePopupModalBtnClick: PropTypes.func,
  activeProduct: PropTypes.shape({
    productName: PropTypes.string,
  }),
};

Signature.defaultProps = {
  getDataFromServer: () => {},
  handleContinue: () => {},
  steps: [],
  activeStepID: -1,
  handlePopupModalBtnClick: () => {},
  activeProduct: {},
};

export default Signature;
